import { Trans, useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';

import { ExternalLink, Link, Text } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import { authLinkStyle, textStyle } from './AuthLink.css';

type Props = {
  to: 'registration' | 'login';
};

export const AuthLink = ({ to }: Props) => {
  const { t } = useTranslation(['auth']);

  return (
    <div className={authLinkStyle}>
      <Text className={textStyle}>
        {match(to)
          .with('login', () => t('auth:registrationPage.common.loginCta.message'))
          .with('registration', () => t('auth:loginPage.registerCta.message'))
          .exhaustive()}{' '}
        <Link to={to === 'registration' ? routes.register : routes.login}>
          {match(to)
            .with('login', () => t('auth:registrationPage.common.loginCta.action'))
            .with('registration', () => t('auth:loginPage.registerCta.action'))
            .exhaustive()}
        </Link>
      </Text>

      {/* Only show accountant login link on login page */}
      {to === 'registration' && (
        <Text className={textStyle}>
          {t('auth:loginPage.accountantLoginCta.message')}{' '}
          <Trans components={{ accountantLink: <ExternalLink /> }} i18nKey="auth:loginPage.accountantLoginCta.action" />
        </Text>
      )}
    </div>
  );
};
